import { createFileRoute, useParams } from '@tanstack/react-router';

import { PractitionerDetailScreen } from '@/features/practitioners/components/shared/PractitionerDetailScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/practitioners/$practitionerId')({
  beforeLoad: () => {
    requirePermission('practitioner:read');
  },
  component: PlatformPractitionerDetailRoute,
  staticData: { crumb: 'Practitioner' },
});

function PlatformPractitionerDetailRoute() {
  const { practitionerId } = useParams({
    from: '/_staff/admin/platform/practitioners/$practitionerId',
  });
  return <PractitionerDetailScreen practitionerId={practitionerId} surface="platform" />;
}
